'use client'

import { QUERY_ROUTES } from '@/core/constants/routes'
import { useDeleteSearchParam } from '@/core/hooks/use-delete-search-params'
import { Modal, ModalBody } from '@/core/ui/atoms/modal'
import { LoginForm } from '@/features/auth/ui/login/login'
import { useCallback } from 'react'

export const LoginModal = () => {
  const { searchParams, deleteSearchParam } = useDeleteSearchParam()

  const handleClose = useCallback(() => {
    deleteSearchParam(QUERY_ROUTES.login.name, { clientOnly: true })
  }, [deleteSearchParam])

  return (
    <>
      <Modal
        isOpen={
          QUERY_ROUTES.login.value === searchParams.get(QUERY_ROUTES.login.name)
        }
        disableBackdropDismiss
        onClose={handleClose}
        size='lg'
        className='max-h-[90%] max-w-lg overflow-y-hidden rounded-2xl sm:max-h-full'
      >
        <ModalBody className='p-6'>
          <LoginForm onSuccess={handleClose} />
        </ModalBody>
      </Modal>
    </>
  )
}
